mutation DeleteTextMessage($input: TextMessageDeleteInput!) {
    textMessageDelete(input: $input) {
        message {
            id
        }
    }
}
